import { render, staticRenderFns } from "./ListDetails.vue?vue&type=template&id=44855a39"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"
import style0 from "./ListDetails.vue?vue&type=style&index=0&id=44855a39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports